import { Box, Container, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowBackIcon } from "../icons";
import AlgoFirstStep from "../components/algorithm/AlgoFirstStep";
import { useEffect, useState } from "react";
import AlgoSecondStep from "../components/algorithm/AlgoSecondStep";
import AlgoThirdStep from "../components/algorithm/AlgoThirdStep";
import { useRecoilState } from "recoil";
import { selectedAlgoState } from "../recoil";
import { getProject } from "../services/projectService";
import { toast } from "react-toastify";

export default function SelectAlgorithmPage() {
  const { id } = useParams();
  const [projectData, setProjectData] = useState<any>(null);
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [selectedAlgo, setSelectedAlgo] = useRecoilState(selectedAlgoState);
  const [labelList, setLabelList] = useState<string[]>([]);

  useEffect(() => {
    const fetchProjectData = async () => {
      const response = await getProject(Number(id));
      setProjectData(response.project);
      if (response.project.class.length < 1) {
        toast.warning(
          "해당 프로젝트의 라벨이 없습니다. 사전분류 진행 페이지로 넘어갑니다."
        );
      }
    };
    fetchProjectData();
  }, []);

  const handleBackClick = () => {
    // if (currentStep === 3) {
    //   setCurrentStep(1);
    // } else
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
    setSelectedAlgo((prev) => ({
      ...prev,
      algoId: null,
      algoName: null,
    }));
  };

  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "900px",
          height: "680px",
          p: 2,
          border: "1px solid var(--dk-border, #ccc)",
          borderRadius: "6px",
        }}
      >
        {currentStep > 1 && (
          <Box sx={{ width: "100%", justifyContent: "flex-start" }}>
            <IconButton onClick={handleBackClick}>
              <ArrowBackIcon />
            </IconButton>
          </Box>
        )}
        <Box>
          {currentStep === 1 && (
            <AlgoFirstStep setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 2 && (
            <AlgoSecondStep
              setCurrentStep={setCurrentStep}
              projectData={projectData}
            />
          )}
          {currentStep === 3 && (
            <AlgoThirdStep setCurrentStep={setCurrentStep} />
          )}
        </Box>
      </Box>
    </Container>
  );
}
